import axiosIns from '@/plugins/axios'

// モバイルオーダーのオーダーストップ(店舗単位・営業日ごと)。判定の真の所在はバックエンド SelfOrderSetting#order_stopped?
export default {
  /**
   * 現在の状態を取得
   * @returns {Promise} { stopped, manualStatus, businessDate, autoStopAt, autoStopped }
   */
  getSelfOrderStop() {
    return axiosIns.get('/waiter/self_order_stop')
  },

  /**
   * 停止/再開を記録(当日営業日のみ有効。翌営業日は自動停止時刻の設定に従う)
   * @param {Object} params
   * @param {boolean} params.stopped true=停止, false=再開
   */
  updateSelfOrderStop({ stopped }) {
    return axiosIns.patch('/waiter/self_order_stop', { stopped })
  },
}
